import React from 'react';

const AISummaryLocked = ({ chatLogo, currentUrl }) => {
    return (
        <div className="ai-summary-container">
            <div className="ai-summary-card ai-summary-locked">
                <div className="ai-summary-header">
                    <div className="ai-summary-icon">
                        <img src={chatLogo} alt="AI" />
                    </div>
                    <h3>AI Overview</h3> 
                </div>

                <div className="ai-summary-content locked">
                    <p>
                        AI summaries and follow-up questions are available to Directions members.
                    </p>
                     <div className="d-flex gap-2">
                        <a href={`/login?redirect_to=${encodeURIComponent(currentUrl)}`} className="custom-button">
                            Log in
                        </a>
                        <a href="/become-a-member" className="custom-secondary-btn">
                            Become a member
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AISummaryLocked;
